import React, { useState, useEffect } from "react";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch } from "react-redux";
import { ADMIN_ARTICEL_REQUEST_RESET } from "../../../redux/article/articlesConstants";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Link } from "react-router-dom";
import Pagination from "@material-ui/lab/Pagination";
import Snackbar from "@material-ui/core/Snackbar";
import Grid from "@material-ui/core/Grid";
import MuiAlert from "@material-ui/lab/Alert";
import { Formik } from "formik";
import EditIcon from "@material-ui/icons/Edit";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { CircularProgress } from "@material-ui/core";
import Loader from "../../Global/Loader/Index";
import AlertMessage from "../../Global/Message/Alert";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    btnSearch: {
        backgroundColor: "#417557",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#417557",
        },
        color: "#fff",
    },
    btnRed: {
        backgroundColor: "#950000",
        boxShadow: "none",

        "&:hover": {
            backgroundColor: "#950000",
        },
        color: "#fff",
    },
    select: {
        borderRadius: "10px",
        width: "100%",
        height: "34px",
    },
    cursor: {
        cursor: "pointer",
    },
}));

let cat = [];
let subCat = [];
let subSecCat = [];

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const MagazineList = (props) => {
    const classes = useStyles();
    const [pageLoading, setPageLoading] = React.useState(true);
    const [svCategory, setSvCategory] = useState([]);
    const [svSubCategory, setSvSubCategory] = useState([]);
    const [svSubSecCategory, setSvSubSecCategory] = useState([]);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [newCategory, setNewCategory] = useState(1);
    const [articleList, setArticleList] = useState([]);
    const [pages, setPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [id, setId] = useState(0);
    const [searchValue, setSearchValue] = useState("");

    const [loadings, setLoadings] = useState({
        load1: false,
        load2: false,
        load3: false,
    });
    const [open, setOpen] = React.useState(false);
    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });

    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message });
    };
    const dispatch = useDispatch();

    useEffect(() => { dispatch({ type: ADMIN_ARTICEL_REQUEST_RESET }) }, [])

    const toggleOpenAlert = (Type, msg) => {
        setAlert({
            open: true,
            type: Type,
            message: msg,
        });
    };

    const handleClickOpen = (id) => {
        setOpen(true);
        setId(id);
    };

    const handleClose = () => {
        setOpen(false);
        setId("");
    };

    const getArticles = async (mainCategoryId) => {
        setPageLoading(true)
        const key = searchValue.split(" ").join("+");
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/articles?lan=fa&CategoryId=${mainCategoryId}&Keyword=${key}&Page=${currentPage}`,
                config
            );
            setArticleList(data.data.articles);
            setPages(data.data.totalPages);
        } catch (error) {
            console.error(error);
            toggleOpenAlert("error", "خطا در اتصال با سرور");
        }
        setPageLoading(false)
    };

    const deleteArticle = async () => {
        let formData = new FormData();
        formData.append("ArticleId", id);
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.post(
                `/api/admin/articles/delete`,
                formData,
                config
            );
            if (data.status === "ok") {
                toggleOpenAlert("success", "مقاله مورد نظر با موفقیت حذف شد");
                getProductsAgain();
                handleClose();
                setDeleteLoading(false);
            }
            if (data.status === "error") {
                toggleOpenAlert("error", "مشکلی در حذف مقاله پیش آمده است");
                handleClose();
                setDeleteLoading(false);
            }
        } catch (error) {
            console.error(error);
            toggleOpenAlert("error", "خطا در اتصال با سرور");
            setDeleteLoading(false);
        }
    };

    const getProductsAgain = async () => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get("/api/admin/articles", config);
            if (data.status === "ok") {
                setArticleList(data.data.articles);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    useEffect(() => {
        const getCats = async () => {
            setLoadings({
                load1: true,
                load2: false,
                load3: false,
            });
            const config = {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            };
            try {
                const { data } = await axios.get(
                    "/api/admin/articles/getcategories",
                    config
                );
                if (data.status === "ok") {
                    cat = data.data;
                    setSvCategory(cat);
                    setLoadings({
                        load1: false,
                        load2: false,
                        load3: false,
                    });
                }
            } catch (e) {
                console.log(e);
                setLoadings({
                    load1: false,
                    load2: false,
                    load3: false,
                });
            }
        };
        getCats();
    }, []);

    useEffect(() => {
        const getProducts = async () => {
            setPageLoading(true)
            const config = {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            };
            try {
                const { data } = await axios.get("/api/admin/articles", config);
                if (data.status === "ok") {
                    setArticleList(data.data.articles);
                    setPages(data.data.totalPages);
                }
            } catch (e) {
                console.log(e);
            }
            setPageLoading(false)
        };
        getProducts();
    }, []);

    const linker = (type) => {
        switch (type) {
            case 1:
                return "/api/products/getsubcategories?lan=fa&MainCategoryId=";
            case 2:
                return "/api/products/getsecondarysubcategories?lan=fa&SubCategoryId=";
        }
    };

    const handleCatAxios = async (type, catId) => {
        setLoadings({
            load1: false,
            load2: type === 1 ? true : false,
            load3: type === 2 ? true : false,
        });
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };

        try {
            const { data } = await axios.get(linker(type) + catId, config);
            if (data.status === "ok") {
                if (type === 1) {
                    subCat = data.data;
                    setSvSubCategory(subCat);
                    setLoadings({
                        load1: false,
                        load2: false,
                        load3: false,
                    });
                    setSvSubSecCategory({});
                } else {
                    subSecCat = data.data;
                    setSvSubSecCategory(subSecCat);
                    setLoadings({
                        load1: false,
                        load2: false,
                        load3: false,
                    });
                }
            }
        } catch (e) {
            console.log(e);
            setLoadings({
                load1: false,
                load2: false,
                load3: false,
            });
        }
    };

    return (
        <>
            <br />
            <Formik
                style={{ width: "100%" }}
                initialValues={{
                    CategoryId: "",
                    subCategory: "",
                    Keyword: "",
                    page: "1",
                }}
                onSubmit={(values) => {
                    getArticles(values.CategoryId);
                }}
                render={({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    errors,
                    setFieldValue,
                }) => (
                    <>
                        <Grid container>
                            <Grid item md={3}>
                                <Box m={2} mt={0}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel id="demo-simple-select-outlined-label">
                                            {loadings.load1 ? (
                                                <CircularProgress size={12} />
                                            ) : (
                                                "دسته بندی"
                                            )}
                                        </InputLabel>
                                        <Select
                                            fullWidth
                                            name="CategoryId"
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            label={
                                                loadings.load1 ? (
                                                    <CircularProgress size={12} />
                                                ) : (
                                                    "دسته بندی"
                                                )
                                            }
                                            value={values.CategoryId}
                                        >
                                            <MenuItem disabled value="">
                                                <em> انتخاب کنید</em>
                                            </MenuItem>
                                            {svCategory.length > 0 &&
                                                svCategory.map((item) => (
                                                    <MenuItem value={item.id.toString()}>
                                                        {item.title}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Grid>
                            <Grid item xs={5}>
                                <Box mt={1.5}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="لطفا نام مقاله یا کلمات کلیدی را وارد نمایید."
                                        onChange={(e) => setSearchValue(e.target.value)}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={3}>
                                <Box mt={1.5} pl={2}>
                                    <Button
                                        className={classes.btnSearch}
                                        fullWidth
                                        onClick={handleSubmit}
                                        color="seconday"
                                        variant="contained"
                                    >
                                        <SearchIcon />
                    جستجو
                  </Button>
                                </Box>
                            </Grid>
                        </Grid>

                        <Box pt={4} pb={2} px={1}>
                            <Box
                                bgcolor="#950000"
                                borderRadius="10px 10px 0px 0px"
                                color="#fff"
                                p={2}
                                textAlign="center"
                            >
                                <Grid container>
                                    <Grid xs={1}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%"
                                        >
                                            تصویر مقاله
                    </Box>
                                    </Grid>
                                    <Grid xs={2}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%"
                                        >
                                            نام مقاله
                    </Box>
                                    </Grid>
                                    <Grid xs={3}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%"
                                        >
                                            نویسنده
                    </Box>
                                    </Grid>
                                    <Grid xs={1}>
                                        <Box
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%"
                                        >
                                            تاریخ ثبت
                      <br />
                                        </Box>
                                    </Grid>
                                    <Grid xs={3}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%"
                                        >
                                            پیش نمایش متن
                    </Box>
                                    </Grid>
                                    <Grid xs={1}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%"
                                        >
                                            محتوای عربی
                    </Box>
                                    </Grid>
                                    <Grid xs={1}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%"
                                        >
                                            عملیات
                    </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            {(pageLoading) ? (
                                <Box mt={3}>
                                    <Loader text="در حال بارگزاری..." />
                                </Box>
                            ) : (
                                (articleList.length) > 0 ? (
                                    articleList.map((item) => (
                                        <Box
                                            p={2}
                                            bgcolor="#fff"
                                            borderRadius={15}
                                            mt={1}
                                            textAlign="center">
                                            <Grid container>
                                                <Grid xs={1}>
                                                    <img width="100%" src={item.imgURL} />
                                                </Grid>
                                                <Grid xs={2}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%"
                                                    >
                                                        {item.title}
                                                    </Box>
                                                </Grid>
                                                <Grid xs={3}>
                                                    {" "}
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%"
                                                    >
                                                        <img
                                                            width="30px"
                                                            height="30px"
                                                            style={{ borderRadius: "50%" }}
                                                            src={item.user.imgURL}
                                                        />
                              &nbsp;
                              {item.user.fullName}
                                                    </Box>
                                                </Grid>
                                                <Grid xs={1}>
                                                    {" "}
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%"
                                                    >
                                                        {item.date}{" "}
                                                    </Box>
                                                </Grid>
                                                <Grid xs={3}>
                                                    {" "}
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%"
                                                    >
                                                        {item.shortDescription.length > 30
                                                            ? `${item.shortDescription.substring(0, 30)}...`
                                                            : item.shortDescription}
                                                    </Box>
                                                </Grid>
                                                <Grid xs={1}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={item.arContent}
                                                            disabled
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid xs={1}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%"
                                                    >
                                                        <Link
                                                            to={`/article/${item.id}/${item.title.replace(
                                                                /\s+/g,
                                                                "-"
                                                            )}`}
                                                        >
                                                            <a
                                                                style={{ color: "#818181" }}
                                                                className={classes.cursor}
                                                            >
                                                                <VisibilityIcon color="inherit" />
                                                            </a>
                                                        </Link>
                                                        <a
                                                            className={classes.cursor}
                                                            onClick={() => props.onEdit(true, item.id)}
                                                        >
                                                            <EditIcon color="primary" />
                                                        </a>
                                                        <a onClick={null}>
                                                            <DeleteForeverIcon
                                                                className={classes.cursor}
                                                                style={{ fill: "#950000" }}
                                                                onClick={() => handleClickOpen(item.id)}
                                                            />
                                                        </a>

                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    ))
                                ) : (
                                    <>
                                        <Box mt={3} mb={1}>
                                            <AlertMessage variant="info">
                                                موردی جهت نمایش وجود ندارد.
                                    </AlertMessage>
                                        </Box>
                                    </>
                                )
                            )}
                            <Box
                                display="flex"
                                justifyContent="center"
                                mt={2}
                                mb={2}
                                alignItems="center"
                            >
                                <Pagination
                                    count={pages}
                                    page={currentPage}
                                    variant="outlined"
                                    shape="rounded"
                                    onChange={(e, value) => {
                                        setCurrentPage(value);
                                        handleSubmit();
                                    }}
                                />
                            </Box>
                        </Box>
                    </>
                )}
            />
            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={toggleCloseAlert}
            >
                <Alert onClose={toggleCloseAlert} severity={alert.type}>
                    {alert.message}
                </Alert>
            </Snackbar>

            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">
                    آیا از حذف این مقاله اطمینان دارید؟
        </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Box
                        textAlign="center"
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                        width="100%"
                    >
                        <Button variant="contained" onClick={handleClose} color="secondary">
                            انصراف
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button
                            className={classes.btnRed}
                            variant="contained"
                            onClick={deleteArticle}
                        >
                            {deleteLoading ? (
                                <CircularProgress size={25} color="inherit" />
                            ) : (
                                <>
                                    {" "}
                                    <DeleteForeverIcon />
                  حذف
                </>
                            )}
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default MagazineList;
